import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';
import type { StoreListItem } from '../types/store';

interface StoreState {
  currentStore: StoreListItem | null;
  storeId: string | null;
  permissions: string[];
  role: string | null;
  setCurrentStore: (store: StoreListItem) => void;
  clearStore: () => void;
}

const StoreContext = createContext<StoreState>({
  currentStore: null,
  storeId: null,
  permissions: [],
  role: null,
  setCurrentStore: () => {},
  clearStore: () => {},
});

export function StoreProvider({ children }: { children: ReactNode }) {
  const [currentStore, setStore] = useState<StoreListItem | null>(null);

  const setCurrentStore = useCallback((store: StoreListItem) => {
    setStore(store);
  }, []);

  const clearStore = useCallback(() => {
    setStore(null);
  }, []);

  return (
    <StoreContext.Provider
      value={{
        currentStore,
        storeId: currentStore?.id ?? null,
        permissions: currentStore?.permissions ?? [],
        role: currentStore?.role ?? null,
        setCurrentStore,
        clearStore,
      }}
    >
      {children}
    </StoreContext.Provider>
  );
}

export function useStore() {
  return useContext(StoreContext);
}
